<template>
  <div>
      <div >
        <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">其他险种管理-新增</div>
        <el-button style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return">返回</el-button>

        <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
      <!-- 查询框 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm"> 
            <el-row>
                <el-col :span="12">
                <el-form-item label="保单名称" prop="insurance_name" style="margin-top:80px;width:80%">
                    <el-input v-model="ruleForm.insurance_name" placeholder="请输入保单名称"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="投保账户" prop="insure_account" style="margin-top:80px;width:80%">
                    <el-input v-model="ruleForm.insure_account" placeholder="请输入投保账户"></el-input>
                </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :span="12">
                    <el-form-item label="投保内容" prop="dictionaries_id" >
                    <el-select v-model="ruleForm.dictionaries_id" style="width:74%" placeholder="请选择投保内容" clearable>
                      <el-option
                        v-for="item in cxList"
                        :key="item.id"
                        :label="item.data"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="生效时间" required>
                    <el-col :span="9">
                    <el-form-item prop="start_date">
                        <el-date-picker type="date" placeholder="请选择" v-model="ruleForm.start_date" value-format="yyyy-MM-dd" style="width:88%"></el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1"> - </el-col>
                    <el-col :span="9">
                    <el-form-item prop="end_date">
                        <el-date-picker type="date" placeholder="请选择" v-model="ruleForm.end_date" value-format="yyyy-MM-dd" style="width:88%"></el-date-picker>
                    </el-form-item>
                    </el-col>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="承保公司" prop="company_id" >
                    <el-select v-model="ruleForm.company_id" style="width:74%" placeholder="请选择承保公司" clearable>
                      <el-option
                          v-for="item in cbgsList"
                          :key="item.id"
                          :label="item.company_name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="单价" prop="unit_price" style="width:80%">
                    <el-input v-model="ruleForm.unit_price" placeholder="请输入单价"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="保单号" prop="policy_no" style="width:80%">
                    <el-input v-model="ruleForm.policy_no" placeholder="请输入保单号"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="保费" prop="premium" style="width:80%">
                    <el-input type="number" v-model="ruleForm.premium" placeholder="请输入保费"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="保额" prop="insured_amount" style="width:80%">
                    <el-input type="number" v-model="ruleForm.insured_amount" placeholder="请输入保额"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="免赔额、比例" prop="proportion" style="width:80%">
                    <el-input v-model="ruleForm.proportion" placeholder="请输入免赔额、比例"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <!-- <el-row>
                <el-form-item label="适用范围" prop="project_id">
                <el-col :span="4">    
                    <el-select v-model="ruleForm.company_id" placeholder="请选择城市公司"
                        @change="Plate" clearable>
                        <el-option v-for="item in fgsList" :key="item.id"
                            :label="item.organize_name" :value="item.id">
                        </el-option>
                    </el-select>
                    
                </el-col>
                <el-col :span="4">
                    <el-select v-model="ruleForm.plate_id"
                        :placeholder="plate_placeholder" @change="Project" clearable>
                        <el-option v-for="item in plateList" :key="item.id" :label="item.organize_name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="ruleForm.project_id"
                      :placeholder="project_placeholder" clearable>
                      <el-option v-for="item in projectList" :key="item.id" :label="item.project_name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="ruleForm.post_id" 
                     placeholder="请选择岗位" clearable>
                      <el-option v-for="item in postList" :key="item.id" :label="item.post_name" 
                        :value="item.id">
                      </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="ruleForm.age_id" 
                     placeholder="请选择年龄段" clearable>
                      <el-option v-for="item in ageList" :key="item.id" :label="item.data" 
                        :value="item.id">
                      </el-option>
                    </el-select>
                </el-col>
                </el-form-item>
            </el-row> -->

            <el-row>
                <el-col :span="12">
                <el-form-item label="承保公司联系人" prop="company_contacts" style="width:80%">
                    <el-input v-model="ruleForm.company_contacts" placeholder="请输入承保公司联系人"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="承保公司联系电话" prop="company_telephone" style="width:80%">
                    <el-input v-model="ruleForm.company_telephone" placeholder="请输入承保公司联系电话"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="备注" prop="remarks">
                <el-input v-model="ruleForm.remarks" style="width:89%" placeholder="请输入备注内容"></el-input>
            </el-form-item>

            <el-row>
                <el-col :span="12">
                <el-form-item label="备用1" prop="spare1" style="width:80%">
                    <el-input v-model="ruleForm.spare1" placeholder="请输入"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="备用2" prop="spare2" style="width:80%">
                    <el-input v-model="ruleForm.spare2" placeholder="请输入"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="保单扫描件" prop="insurance_url" style="width:80%">
                  <el-upload :action="$globals.http + 'file/upload'" list-type="picture-card"
                  :on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove" :file-list="ruleForm.insurance_url"
                  :on-success="handleAvatarSuccess">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="ruleForm.insurance_url" alt="">
                </el-dialog>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="其他附件" prop="enclosure_url" style="width:80%">
                  <el-upload
                    class="upload-demo"
                    :action="$globals.http + '/file/upload'" 
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="uploadFujian"
                    :before-remove="beforeRemove"
                    multiple
                    :on-exceed="handleExceed"
                    :file-list="ruleForm.enclosure_url"    
                    :v-model="ruleForm.enclosure_url"
                  >
                <el-button type="goon" style="font-size:10px;width:100px" >上传附件</el-button>
                </el-upload>
                </el-form-item>
                </el-col>
            </el-row>

        <el-form-item style="margin-left:550px">
            <el-button type="goon" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
        </el-form>

      </div>
      
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        cxList:[],
        cbgsList:[],
        fgsList:[],
        ageList:[],
        postList:[],
        //板块
        plate_placeholder: "请选择版块",
        plateList: [],
        //项目
        project_placeholder: "请选择项目",
        projectList: [],
        ruleForm: {
          id:'',
          plate_id:'',
          post_id:'',
          age_id:'',
          project_id:'',
          dictionaries_id:'',
          insurance_name:'',
          insure_account:'',
          insured_amount:'',
          start_date:'',
          proportion:'',
          end_date:'',
          company_id:'',
          unit_price:'',
          policy_no:'',
          premium:'',
          company_contacts:'',
          company_telephone:'',
          remarks:'',
          spare1:'',
          spare2:'',
          insurance_url:'',
          enclosure_url:'',
        },
        rules: {
          insurance_name: [
            {required: true, message: '请输入保单名称', trigger: 'blur' },
          ],
          insure_account: [
            {required: true, message: '请输入投保账户', trigger: 'blur' }
          ],
          start_date: [
            {required: true, message: '请选择时间', trigger: 'blur' }
          ],
           end_date: [
            {required: true, message: '请选择时间', trigger: 'blur' }
          ],
           company_id: [
            {required: true, message: '请选择承保公司', trigger: 'blur' }
          ],
           dictionaries_id: [
            {required: true,  message: '请选择投保内容', trigger: 'blur' }
          ],
           unit_price: [
            {required: true, message: '请输入单价', trigger: 'blur' }
          ],
           policy_no: [
            {required: true, message: '请输入保单号', trigger: 'blur' }
          ],
           premium: [
            {required: true, message: '请输入保费', trigger: 'blur' }
          ],
          insured_amount: [
            {required: true, message: '请输入保额', trigger: 'blur' }
          ],
          proportion: [
            { required: true, message: '请输入免赔额、比例', trigger: 'blur' }
          ],
          company_contacts: [
            { required: true, message: '请输入承保公司联系人', trigger: 'blur' }
          ],
          company_telephone: [
            { required: true, message: '请输入承保公司联系电话', trigger: 'blur' }
          ],
          insurance_url: [
            { required: true, message: '请上传保单扫描件'}
          ],
          project_id:[
            { required: true, message: '请选择适用范围', trigger: 'blur' }
          ],
        }
      };
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.ruleForm.insurance_url = res.data.fileUrl;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },   
      uploadFujian(res, file) {
       this.ruleForm.enclosure_url = res.data.fileUrl;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            var url = 'OtherInsurance/insert';
            var record = {
              insurance_name: this.ruleForm.insurance_name,
              insure_account: this.ruleForm.insure_account,
              dictionaries_id:this.ruleForm.dictionaries_id,
              start_date: this.ruleForm.start_date,
              end_date: this.ruleForm.end_date,
              company_id: this.ruleForm.company_id,
              unit_price: this.ruleForm.unit_price,
              policy_no: this.ruleForm.policy_no,
              premium: this.ruleForm.premium,
              insured_amount: this.ruleForm.insured_amount,
              proportion: this.ruleForm.proportion,
              company_contacts: this.ruleForm.company_contacts,
              company_telephone: this.ruleForm.company_telephone,
              remarks: this.ruleForm.remarks,
              spare1: this.ruleForm.spare1,
              spare2: this.ruleForm.spare2,
              insurance_url: this.ruleForm.insurance_url,
              enclosure_url: this.ruleForm.enclosure_url,
              project_id: this.ruleForm.project_id,
              post_id: this.ruleForm.post_id,
              age_id: this.ruleForm.age_id,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.$message.success(data);
                    this.Return();
                } else {
                    this.$message.warning(data);
                }
            }

        } else {
            console.log('error submit!!');
            return false;
        }
        });
      },
      //选择板块
      async Plate(e) {
          if (e != undefined && e != null && e != '') {
              this.plate_placeholder = "请先选择城市公司";
              this.plateList = [];
              this.project_placeholder = "请先选择版块";
              this.projectList = [];
          } else {
              this.ruleForm.plate_id = "";
              this.plate_placeholder = "请先选择城市公司";
              this.plateList = [];
              this.ruleForm.project_id = "";
              this.project_placeholder = "请先选择版块";
              this.projectList = [];
          }

          if (this.ruleForm.company_id != null && this.ruleForm.company_id != '') {
              var plateList = await this.$globals.AxiosPost("organize/selectOrganizesing", {
                  organize_id: this.ruleForm.company_id
              });

              this.plate_placeholder = "请选择";
              this.plateList = plateList.data;
          }
      },
      //选择项目
      async Project(e) {
          if (e != undefined && e != null && e != '') {
              this.project_placeholder = "请先选择版块";
              this.projectList = [];
          } else {
              this.ruleForm.project_id = "";
              this.project_placeholder = "请先选择版块";
              this.projectList = [];
          }

          if (this.ruleForm.plate_id != null && this.ruleForm.plate_id != '') {
              var projectList = await this.$globals.AxiosPost("project/selectFind", {
                  organize_id: this.ruleForm.plate_id
              });
              this.project_placeholder = "请选择";
              this.projectList = projectList.data;
          }
      },
      Return(){
        this.ruleForm.plate_id = "";
        this.plate_placeholder = "请先选择城市公司";
        this.plateList = [];
        this.ruleForm.project_id = "";
        this.project_placeholder = "请先选择版块";
        this.projectList = [];
        this.$parent.Return();
      },
    },
    async created() {
      this.ruleForm = this.$parent.ruleForm;
      // 分公司
    var fgsList = await this.$globals.AxiosPost("organize/selectOrganizes", {});
    this.fgsList = fgsList.data;
    // 岗位
    var postList = await this.$globals.AxiosPost("post/selectFind", {});
    this.postList = postList.data;
    // 承保公司
    var cbgsList = await this.$globals.AxiosPost("company/SelectAll", {});
    this.cbgsList = cbgsList.data;  
    // 年龄段类型
    var ageList = await this.$globals.AxiosPost("/dictionaries/selectFind", {data_grouping: "age_group"});
    this.ageList = ageList.data; 
    // 投保内容
    var cxList = await this.$globals.AxiosPost("/dictionaries/selectFind", {data_grouping: "insurance_type"});
    this.cxList = cxList.data; 
  },
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Qtxzgl_add.vue?13aa1f11